import React, { useState, useEffect } from 'react';
import Avatar from '../../components/Avatar';
import { UserCard } from '../../components/Card';
import Notifications from '../../components/Notifications';
import SearchInput from '../../components/SearchInput';
import { notificationsData } from '../../demos/header';
import withBadge from '../../hocs/withBadge';
import {
  MdClearAll,
  MdExitToApp,
  MdHelp,
  MdNotificationsActive,
  MdNotificationsNone,
  MdPersonPin,
  MdSettingsApplications,
} from 'react-icons/md';
import {
  Button,
  ListGroup,
  ListGroupItem,
  Nav,
  Navbar,
  NavItem,
  NavLink,
  Popover,
  PopoverBody,
} from 'reactstrap';
import bn from '../../utils/bemnames';
import { parseJWT } from '../../utils/jwtUtils';
const bem = bn.create('header');
import { useNavigate } from 'react-router-dom';

const MdNotificationsActiveWithBadge = withBadge({
  size: 'md',
  color: 'primary',
  style: {
    top: -10,
    right: -10,
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  children: <small>3</small>,
})(MdNotificationsActive);

const Header = () => {
  // navigate
  const navigate = useNavigate();

  const [isOpenNotificationPopover, setOpenNotificationPopover] =
    useState(false);
  const [isNotificationConfirmed, setNotificationConfirmed] = useState(false);
  const [isOpenUserCardPopover, setOpenUserCardPopover] = useState(false);

  const toggleNotificationPopover = () => {
    setOpenNotificationPopover(!isOpenNotificationPopover);
    if (!isNotificationConfirmed) {
      setNotificationConfirmed(true);
    }
  };

  const toggleUserCardPopover = () => {
    setOpenUserCardPopover(!isOpenUserCardPopover);
  };

  const handleSidebarControlButton = event => {
    event.preventDefault();
    event.stopPropagation();
    document.querySelector('.cr-sidebar').classList.toggle('cr-sidebar--open');
  };

  const token = JSON.parse(localStorage.getItem('userInfo'));
  // Parse the token
  // const userRole = parseJWT(token);
  // console.log('user info : ', token.data);

  const handleLogout = () => {
    localStorage.clear();
    navigate('/login');
  };
  const handleProfile = () => {
    navigate('/profile');
  };
  const handleSetting = () => {
    navigate('/setting');
  };
  const handleHelp = () => {
    navigate('/helps');
  };

  return (
    <Navbar light expand className={bem.b('bg-white')}>
      <Nav navbar className="mr-2">
        <Button outline onClick={handleSidebarControlButton}>
          <MdClearAll size={25} />
        </Button>
      </Nav>
      <Nav navbar>
        <SearchInput />
      </Nav>

      <Nav navbar className={bem.e('nav-right')}>
        <NavItem className="d-inline-flex">
          <NavLink id="Popover1" className="position-relative">
            {isNotificationConfirmed ? (
              <MdNotificationsNone
                size={25}
                className="text-secondary can-click"
                onClick={toggleNotificationPopover}
              />
            ) : (
              <MdNotificationsActiveWithBadge
                size={25}
                className="text-secondary can-click animated swing infinite"
                onClick={toggleNotificationPopover}
              />
            )}
          </NavLink>
          <Popover
            placement="bottom"
            isOpen={isOpenNotificationPopover}
            toggle={toggleNotificationPopover}
            target="Popover1"
          >
            <PopoverBody>
              <Notifications notificationsData={notificationsData} />
            </PopoverBody>
          </Popover>
        </NavItem>

        <NavItem>
          <NavLink id="Popover2">
            <Avatar onClick={toggleUserCardPopover} className="can-click" />
          </NavLink>
          <Popover
            placement="bottom-end"
            isOpen={isOpenUserCardPopover}
            toggle={toggleUserCardPopover}
            target="Popover2"
            className="p-0 border-0"
            style={{ minWidth: 250 }}
          >
            <PopoverBody className="p-0 border-light">
              <UserCard
                title={token?.data?.firstName || 'Loading...'}
                subtitle={token?.data?.phone || 'Loading...'}
                text="Last updated 3 mins ago"
                className="border-light"
              >
                <ListGroup flush>
                  <ListGroupItem
                    tag="button"
                    action
                    className="border-light d-flex align-items-center gap-2"
                    onClick={handleProfile}
                  >
                    <MdPersonPin /> Profile
                  </ListGroupItem>
                  <ListGroupItem
                    tag="button"
                    action
                    className="border-light d-flex align-items-center gap-2"
                    onClick={handleSetting}
                  >
                    <MdSettingsApplications /> Settings
                  </ListGroupItem>
                  <ListGroupItem
                    tag="button"
                    action
                    className="border-light d-flex align-items-center gap-2"
                    onClick={handleHelp}
                  >
                    <MdHelp /> Help
                  </ListGroupItem>
                  <ListGroupItem
                    tag="button"
                    action
                    className="border-light d-flex align-items-center gap-2"
                    onClick={handleLogout}
                  >
                    <MdExitToApp /> Signout
                  </ListGroupItem>
                </ListGroup>
              </UserCard>
            </PopoverBody>
          </Popover>
        </NavItem>
      </Nav>
    </Navbar>
  );
};

export default Header;
